const Unauthorized = () => {
    return (
        <div className="container h-screen mx-auto mt-32 text-3xl">YOU AREE UNAUTHORIZED TO VIEW THIS PAGE</div>
    )
}

export default Unauthorized;